import { httpClient, getAgencyKey } from "@utils";
import { CompanySettingLimited } from "@api-types/company/CompanySettingsLimitedDto";
import { getApplicationHeaders } from "@utils";
const requestHeaders = {
	"Content-Type": "application/json",
};

export class CompanySettingsApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/company-settings`;
	}

	static getLimitedCompanySettings(): Promise<CompanySettingLimited> {
		const headers = getApplicationHeaders();
		const url = `${this.baseUrl}/limited-by-agency/${getAgencyKey()}`;
		return httpClient.get(
			url,
			{ ...headers, ...requestHeaders },
			{
				responseType: "json",
			}
		);
	}
}
